<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.6714 11.6908C24.0921 12.16 24.0921 12.84 23.6714 13.3092C22.746 14.341 21.1924 15.8971 19.2399 17.1921C17.2843 18.4892 14.9657 19.5 12.5 19.5C10.0343 19.5 7.71566 18.4892 5.76007 17.1921C3.80763 15.8971 2.25396 14.341 1.3286 13.3092C0.907894 12.84 0.907894 12.16 1.3286 11.6908C2.25396 10.659 3.80763 9.10291 5.76008 7.80788C7.71566 6.51078 10.0343 5.5 12.5 5.5C14.9657 5.5 17.2843 6.51078 19.2399 7.80788C21.1924 9.10291 22.746 10.659 23.6714 11.6908Z"
      stroke="currentColor"
    />
    <circle cx="12.5" cy="12.5" r="3" stroke="currentColor" />
    <path d="M22 3L3 22" stroke="currentColor" />
  </svg>
</template>
